import { LoadableLazy } from '@confluence/loadable';

export const RecentContentMenuLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RecentContentMenu" */
				'../../ContentMenu/RecentContentMenu.tsx'
			)
		).RecentContentMenu,
});
